import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../../model/Dictionary';
import MealsSelection from './MealsSelection';
import MealsSelectionHeader from '../mealsHeader/MealsSelectionHeader';

const MealsSelectionContainer = ({
  selectedRoute,
  selectedPassenger,
  handleClose,
  onConfirmationCallback,
}) => (
  <div>
    <MealsSelectionHeader
      title={Dictionary.meal.title}
      activePassenger={selectedPassenger}
      handleClose={handleClose}
    />
    <MealsSelection
      routeId={selectedRoute ? selectedRoute.id : ''}
      activePassenger={selectedPassenger}
      onConfirmationCallback={onConfirmationCallback}
    />
  </div>
);

MealsSelectionContainer.propTypes = {
  selectedPassenger: PropTypes.string,
  selectedRoute: PropTypes.object,
  onConfirmationCallback: PropTypes.func,
  handleClose: PropTypes.func,
};

export default MealsSelectionContainer;



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsSelection/MealsSelectionContainer.js